// @flow
import { combineReducers } from 'redux'

import { accountReducer } from '@modules/account'
import { apiReducer } from '@modules/api'
import { appshellReducer } from '@modules/appshell'
import { authReducer } from '@modules/auth'
import { cartReducer } from '@modules/cart'
import { checkoutReducer } from '@modules/checkout'
import { productReducer } from '@modules/product'
import { snackbarReducer } from '@modules/snackbar'
import { staticReducer } from '@modules/staticPages'
import { appReducer } from '../appState'

export const getRootReducer = (asyncReducers: Object = {}): Object =>
  combineReducers({
    account: accountReducer,
    api: apiReducer,
    appshell: appshellReducer,
    auth: authReducer,
    cart: cartReducer,
    checkout: checkoutReducer,
    product: productReducer,
    snackbar: snackbarReducer,
    staticPages: staticReducer,
    app: appReducer,
    ...asyncReducers
  })

export default getRootReducer
